export default __webpack_public_path__ + "assets/031b81dabcc279517789a5dc4a3cf9bd.png";